__turbopack_context__.v({
  "actions": "page-module__F0TaWa__actions",
  "actions__row": "page-module__F0TaWa__actions__row",
  "card": "page-module__F0TaWa__card",
  "conditionalQuestion": "page-module__F0TaWa__conditionalQuestion",
  "errorMessage": "page-module__F0TaWa__errorMessage",
  "field": "page-module__F0TaWa__field",
  "fieldError": "page-module__F0TaWa__fieldError",
  "fieldGroup": "page-module__F0TaWa__fieldGroup",
  "field__input": "page-module__F0TaWa__field__input",
  "field__label": "page-module__F0TaWa__field__label",
  "intro__cta": "page-module__F0TaWa__intro__cta",
  "intro__stat": "page-module__F0TaWa__intro__stat",
  "intro__stats": "page-module__F0TaWa__intro__stats",
  "languageControl": "page-module__F0TaWa__languageControl",
  "languageControl__notice": "page-module__F0TaWa__languageControl__notice",
  "languageMenu": "page-module__F0TaWa__languageMenu",
  "languageMenu__label": "page-module__F0TaWa__languageMenu__label",
  "languageMenu__list": "page-module__F0TaWa__languageMenu__list",
  "languageMenu__option": "page-module__F0TaWa__languageMenu__option",
  "languageMenu__summary": "page-module__F0TaWa__languageMenu__summary",
  "languageMenu__value": "page-module__F0TaWa__languageMenu__value",
  "loadingOverlay": "page-module__F0TaWa__loadingOverlay",
  "progressbar": "page-module__F0TaWa__progressbar",
  "progressbar__fill": "page-module__F0TaWa__progressbar__fill",
  "questionError": "page-module__F0TaWa__questionError",
  "questionStack": "page-module__F0TaWa__questionStack",
  "result": "page-module__F0TaWa__result",
  "result__icon": "page-module__F0TaWa__result__icon",
  "root": "page-module__F0TaWa__root",
  "shell": "page-module__F0TaWa__shell",
  "step": "page-module__F0TaWa__step",
  "step__eyebrow": "page-module__F0TaWa__step__eyebrow",
  "step__lede": "page-module__F0TaWa__step__lede",
  "step__title": "page-module__F0TaWa__step__title",
});
